import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { KTSVG, toAbsoluteUrl } from '../../../_metronic/helpers';
import { getProject, goToLink, loginLogout } from '../projectData';
import { checkCartItemIsPysical } from '../api';


/**
 * RedemDetails component
 * Displays details of a redemption item, including image, description, points, and redeem button. Handles physical/voucher logic and point validation.
 */
const RedemDetails = () => {
    const [isPysicalProduct, setisPysicalProduct] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const item = location.state?.itemValue;
    const dashboard = location.state?.dashboard;
    const project = getProject()

    useEffect(() => {
        if (item.gift_type === 1) {
            checkCartItemIsPysical({ project_key: project?.pkey }).then((d) => {
                if (d?.data?.id > 0) {
                    setisPysicalProduct(d.data);
                }
            }).catch((error) => {
                loginLogout(error.response)
            })
        }
    }, [item, project]);

    return (
        <div className='container bg-white p-4 vh-100'>
            {item && item?.gifts_id ? (
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='card p-4 border border-secondary'>
                            <img className='card-img' src={item?.medium_image_url ? item?.medium_image_url : toAbsoluteUrl('/media/logos/blank-big.jpg')} alt={item?.gift_short_name} />
                            <div className='card-title mt-3 fs-3'>{item?.gift_short_name}</div>
                            <div className='text-danger fs-4 fw-semibold'>Points: {item?.gift_point}</div>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className="fw-semibold mt-3">
                            <div className="fs-6 text-break text-gray-700">
                                {item?.gift_description ?
                                    <div dangerouslySetInnerHTML={{ __html: item?.gift_description }} />
                                    : <>{item?.gift_sort_description ?
                                        <div dangerouslySetInnerHTML={{ __html: item?.gift_sort_description }} />
                                        : <>No description added</>}
                                    </>
                                }
                            </div>
                        </div>
                        {(dashboard?.totalBalance >= item?.gift_point) ?
                            <>
                                {Number(item?.gift_type) === 3 ? //if voucher
                                    <button onClick={() => goToLink(navigate, `/customer/redem-addtocart-detail`, item)}
                                        className='btn btn-danger mt-3 w-100 mb-4'>Redeem</button>

                                    : <>
                                        {!isPysicalProduct ? <button onClick={() => goToLink(navigate, `/customer/redem-detail/selectRedem-type/${item.gifts_id}`, { itemValue: item, dashboard: dashboard })}
                                            className='btn btn-danger mt-3 w-100 mb-4'>Redeem</button>
                                            : <button onClick={() => goToLink(navigate, `/customer/redem-addtocart-detail`, {
                                                ...item,
                                                userAddress: isPysicalProduct
                                            })} className='btn btn-danger mt-3 w-100 mb-4'>Redeem</button>
                                        }

                                    </>
                                }
                            </>
                            : <div className="notice d-flex bg-light-danger rounded border-primary border border-dashed mt-5 mb-9 p-6">
                                <span className="svg-icon svg-icon-2tx svg-icon-primary me-4">
                                    <KTSVG path='/media/icons/duotune/general/gen044.svg' className='svg-icon-3x svg-icon-danger' />
                                </span>
                                <div className="d-flex flex-stack flex-grow-1">
                                    <div className="fw-semibold">
                                        <div className="fs-6 text-gray-700 gap-3 ">You do not have enough points to redeem this gift.
                                            {/* <Link to="/customer/dashboard" className="fw-semibold"> Back</Link> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            ) : (
                <p>No item data</p>
            )
            }
        </div >
    )
}

export default RedemDetails